import $ from 'jquery';
import wishlist from 'modules/wishlist';

$(function() {
    wishlist.checkWihlistTagId();
    wishlist.bindWishListEvent();
    if ($('#brand-inquiry-email-form').length) {
        $('#brand-inquiry-email-form').submit(function (e) {
            e.preventDefault();
            var brand = $(this).data('brand');
            var emailField = $('#brand-inquiry-email-address');
            var email = emailField.val();
            if (!email || $.trim(email).length == 0) {
                emailField.closest('.field').addClass('is-error');
            } else if (validateEmailField(email)) {
                saveBrandInquiryEmail(brand, email);
            }
        });
        $('#brand-inquiry-email-address').keyup(function () {
            $(this).closest('.field').removeClass('is-error');
        });
    }
});

function saveBrandInquiryEmail(brand, email) {
    var dataObject = {
        brand:brand,
        email: email
    };
    var url = window.rcProps ? window.rcProps.brandEmailSaveHref : "";
    var confirmNotificationUrl = window.rcProps ? window.rcProps.brandEmailConfirmNotificationHref : "";
    $.post(url, dataObject, function() {
        $('#brand-inquiry-email-address').val("");
        $.modal({
            url: confirmNotificationUrl,
            type: 'notification',
            triggerOpen: true,
        });
    });
}

function validateEmailField(email){
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}




// WEBPACK FOOTER //
// ./src/scripts/entry-points/lp/index.js